<template>
  <div style="padding: 30px;" >
	  <h2 style="font-size: 22px; color: #222; margin: 0 0 30px 0; font-weight: 700;">How do I delete my TimeGather account?</h2>
    
	 <!-- 步骤1 -->
	    <div style="margin-bottom: 20px;">
	        <p style="font-size: 16px; font-weight: 600; margin: 0 0 10px 0;">1. Tap your avatar to enter the profile details page.</p>
	        <img src="../../static/1.png" alt="Tap avatar to enter profile page" style="width: 100%; max-width: 500px; height: auto; border-radius: 8px;"/>
	    </div>
	
	    <!-- 步骤2 -->
	    <div style="margin-bottom: 20px;">
	        <p style="font-size: 16px; font-weight: 600; margin: 0 0 10px 0;">2. Click the "Delete Account" button at the bottom to delete your current account information.</p>
	        <img src="../../static/2.png" alt="Click Delete Account button" style="width: 100%; max-width: 500px; height: auto; border-radius: 8px;"/>
	    </div>
	
	    <!-- 步骤3 -->
	    <div>
	        <p style="font-size: 16px; font-weight: 600; margin: 0 0 10px 0;">3. Click "Confirm Delete" to take effect immediately. This will instantly delete the current user and all associated information.</p>
	        <img src="../../static/3.png" alt="Confirm Delete account" style="width: 100%; max-width: 500px; height: auto; border-radius: 8px;"/>
	    </div>
   </div>
</template>
<script>
    export default {
        name: 'Fruit',
        data () {
            return {
              
            }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  .delivery_border{
    height: auto;
    margin: 20px;
    width: 55%;
    /*border-radius: 6px;*/
    /*border: 1px solid #EBEEF5;*/
  }
  .delivery_border_img{
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }
  .delivery_border_title{
    margin-top: 10px;
    font-size: 1.25em;
    font-weight: normal;
  }
  .delivery_border_content{
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: normal;
  }
  .fruit_img{
    height: 550px;width: 100%;
  }
  .fruit_product_img{
    height: 500px;
    width: 260px;
  }
  .deliver_parent{
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .deliver_img_parent{
    width: 30%;
    height: auto;
  }
  .delivery{
    display: flex;
    height: 550px;
    width: 90%;
    margin: auto;
    justify-content: center;
    align-items: center;
  }
  /* 屏幕设备适配 max-device-width: 400px */
  @media screen and (max-device-width: 415px){
    .fruit_img{
      height: 250px;width: 100%;
    }
    .fruit_product_img{
      height: 400px;
      width: 240px;
    }
    .delivery_border_img{
      margin-top: 20px;
      width: 70px;
      height: 70px;
    }
    .deliver_img_parent{
      width: 100%;
      float: left;
      height: 400px;
    }
    .deliver_parent{
      float: left;
      margin-top: 5px;
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .delivery_border{
      height: auto;
      margin:10px 0 auto;
      width: 100%;
      float: right;
      border-radius: 6px;
      border: 1px solid #EBEEF5;
    }
    .delivery{
      display: flex;
      width: 90%;
      height: auto;
      margin: auto;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .delivery_border_title{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
    }
    .delivery_border_content{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }
</style>